import { Modal } from "antd";
import { CustomModalProps } from "../../types";

export default function CustomModal({
  title = "",
  open,
  centered = true,
  disableCloseBtn = false,
  handleClose,
  children,
  className = "",
  subTitle = null,
  ...rest
}: CustomModalProps) {
  return (
    <Modal
      title={title}
      centered={centered}
      className={`custom-modal ${className}`}
      open={open}
      onCancel={() => !disableCloseBtn && handleClose()}
      footer={null}
      {...rest}
    >
      {subTitle}
      <div className="p-6">{children}</div>
    </Modal>
  );
}
